<template>
    <div>
            <!-- 弹框提示 -->
    <div v-show="status" class="mydialog">
      <div class="dialog_mask"></div>
      <div class="dialog_box"  v-if="dtype == 'txt'">
        <div class="mydialog_content">
            <div>
                {{title}}
            </div>
            
        </div>
        <div class="footer">
          <div class="calcel" @click="close">
            <div>取消</div>
          </div>
          <div class="btnOk" @click="btnok">
            <div>确认</div>
          </div>
        </div>
      </div>
      <div class="dialog_box"  v-if="dtype == 'img'">
        <div class="mydialog_content">
            <div class="alert_msg">
                 <slot name="img"></slot>
                <div style="margin-top: 20px">{{desc}}</div>
            </div>
        </div>
      </div>
    </div>
    </div>
</template>
<script>
export default {
    props:{
        status:{
            type:Boolean,
            default:false,
        },
        dtype:{
            type:String,
            default:'txt',
        },
        desc:{
             type:String,
            default:'',
        },
        title:{
            type:String,
            default:''
        },
        values:{
             type:String,
            default:''
        }
    },
    data() {
        return {
            
        }
    },
    methods:{
        close(){
            this.$emit('close')
        },
        btnok(){
            this.$emit('btnok')
        }
    }
}
</script>
<style lang="scss">
    .mydialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(46, 48, 52, 0.3);
  .alert_msg {
//   position: absolute;
//   top: calc(50% - 142px / 2);
//   left: calc(50% - 248px / 2);
  text-align: center;
  height: 142px;
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.3);
  width: 248px;
  img {
    margin-top: 12px;
    width: 60px;
    height: 60px;
  }
}
  .dialog_mask {
  }
  .dialog_box {
    box-sizing: border-box;
    width: 286px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 152px;
    background: #ffffff;
    box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.3);
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 24px 38px;
    flex-direction: column;
  }
  .mydialog_content {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    display: flex;
    align-items: center;
    flex: 2;
  }
  .footer {
    display: flex;
    justify-content: space-around;
    width: 100%;
    .calcel {
      width: 68px;
      cursor: pointer;
      height: 30px;
      background: #dadada;
      border-radius: 100px;
      text-align: center;
      line-height: 30px;
    }
    .btnOk {
      cursor: pointer;

      text-align: center;
      line-height: 30px;
      width: 68px;
      height: 30px;
      color: #fff;
      background: rgba(114, 30, 220, 1);
      border-radius: 100px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/component/mydialog.vue